// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.driver-.DriverTable {
  width: 100%;
  padding: 20px;
  /* margin-right: 20px; */
  background-color: #ffffff;
  margin-top: 20px;
}

.driver-.DispatcherTable {
  width: 100%;
  padding: 20px;
  /* margin-right: 20px; */
  background-color: #ffffff;
  margin-top: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  text-decoration: none;
  margin-left: 20px;
  margin-top: 60px;
  flex-wrap: wrap; /* Allow wrapping on smaller screens */
}

.header h2 {
  font-weight: bold;
  font-size: 25px;
  line-height: 40px;
  margin-left: 0px;
  flex-grow: 1; /* Make the header title take up available space */
}

.actions {
  display: flex;
  align-items: center;
  margin-right: 35px;
  margin-top: -20px;
  flex-wrap: wrap; /* Allow wrapping of actions on smaller screens */
}

.moreActions {
  display: flex;
  align-items: center;
  margin-right: 35px;
  flex-wrap: wrap; /* Allow wrapping of actions on smaller screens */
}

@media (max-width: 768px) {
  .header {
    flex-direction: column; /* Stack elements vertically on smaller screens */
    align-items: flex-start;
    margin-left: 0px;
  }

  .header h2 {
    margin-bottom: 10px; /* Add space between the header and actions on smaller screens */
  }

  .actions {
    margin-right: 0px;
    margin-top: 10px;
    width: 100%; /* Make actions take the full width on smaller screens */
    justify-content: flex-start;
  }

  .search-wrapper {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 10px; /* Add margin to create space between search box and other elements */
  }

  .newDD {
    /* width: 100%; */
    margin-bottom: 10px;
  }
}

.search-wrapper {
  width: 160px;
  height: 40px;
  padding-left: 11px;
  /* margin-top: 5px; */
  margin-right: 8px;
  padding: 5px 10px;
  border: 1px solid lightgray;
  border-radius: 4px;
  position: relative;
}

.actual-search-wrapper {
  width: 180px;
  height: 40px;
  padding-left: 11px;
  margin-right: 8px;
  padding: 10px 10px;
  border: 1px solid lightgray;
  border-radius: 4px;
  position: relative;
  font-size: 13px;
}

.form-control {
  background-color: transparent;
  border: none;
  height: 100%;
  /* font-size: 1.25rem; */
  width: 100%;
  /* margin-left: 15px; */
}
.form-control:focus {
  outline: none;
}
.search-icon {
  padding-left: 11px;
  margin-top: 5px;
  border-radius: 5px;
  margin-right: 8px;
}
.get-app-button {
  background-color: #ffffff;
  color: #4a4a4a;
  border: 1px solid #d5d5d5;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 15px;
  cursor: pointer;
  margin-right: 10px;
  height: 36px;
}

/* Dth */

.new-driver-button {
  background-color: #79c6e9;
  color: #fff;
  border: 1px solid #79c6e9;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 15px;
  cursor: pointer;
  height: 36px;
}

.get-app-button:hover {
  background-color: #edeff1;
}
.new-driver-button:hover {
  background-color: #67bfe8;
}

.DriverTable {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border: none;
}

.DispatcherTable {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border: none;
}

.newDD {
  align-items: center;
  /* margin-right: 5px; */
  margin-left: 10px;
  margin-top: 0.4%;
  border-radius: 50px;
}

.DriverTable th,
.DriverTable td {
  /* color: #4a4a4a !important; */
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 20px !important;
  text-align: left;
}

.DispatcherTable th,
.DispatcherTable td {
  /* color: #4a4a4a !important; */
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 20px !important;
  text-align: left;
}

.DriverTable th:nth-child(4),
.DriverTable th:nth-child(5),
.DriverTable td:nth-child(4),
.DriverTable td:nth-child(5) {
  font-weight: bold;
}

.DispatcherTable th:nth-child(4),
.DispatcherTable th:nth-child(5),
.DispatcherTable td:nth-child(4),
.DispatcherTable td:nth-child(5) {
  font-weight: bold;
}

/* Styles for tabs */
.tabs {
  display: flex;
  margin-bottom: 20px;
  margin-left: 30px;
  margin-top: -10px;
}

.tabs button {
  background-color: transparent;
  border: none;
  padding: 10px 20px;
  font-size: 17px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease;
  color: #7c7c7c;
  border-bottom: 2px solid transparent;
}

.tabs button.active {
  background-color: transparent;
  color: black;
  border-bottom: 2px solid #72c2e7;
}

.daily-payment-content {
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.driver-inactive {
  font-family: sans-serif;
  color: rgb(223, 222, 222);
}

.driver-inactive tr {
  color: rgb(227, 222, 222);
}
.driver-active {
  font-family: sans-serif;
}
.Field {
  margin: 8px;
}

.clickable-name {
  cursor: pointer;
}

.clickable-name:hover {
  color: #79c6e9;
}

.circular-initial {
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #79c6e9;
  color: white;
  text-align: center;
  vertical-align: middle;
  line-height: 25px;
  font-size: 14px;
  margin-right: 10px;
}

.circular-initiall {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60;
  height: 60;
  border-radius: 50%;
  background-color: #79c6e9;
  color: white;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.disabled-button {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/Css/DriverTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe,EAAE,sCAAsC;AACzD;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY,EAAE,kDAAkD;AAClE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAE,iDAAiD;AACpE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe,EAAE,iDAAiD;AACpE;;AAEA;EACE;IACE,sBAAsB,EAAE,iDAAiD;IACzE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB,EAAE,gEAAgE;EACvF;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW,EAAE,wDAAwD;IACrE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB,EAAE,qEAAqE;EAC5F;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EAErB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAElB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA,QAAQ;;AAER;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf;2BACyB;EACzB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[".driver-.DriverTable {\r\n  width: 100%;\r\n  padding: 20px;\r\n  /* margin-right: 20px; */\r\n  background-color: #ffffff;\r\n  margin-top: 20px;\r\n}\r\n\r\n.driver-.DispatcherTable {\r\n  width: 100%;\r\n  padding: 20px;\r\n  /* margin-right: 20px; */\r\n  background-color: #ffffff;\r\n  margin-top: 20px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  text-decoration: none;\r\n  margin-left: 20px;\r\n  margin-top: 60px;\r\n  flex-wrap: wrap; /* Allow wrapping on smaller screens */\r\n}\r\n\r\n.header h2 {\r\n  font-weight: bold;\r\n  font-size: 25px;\r\n  line-height: 40px;\r\n  margin-left: 0px;\r\n  flex-grow: 1; /* Make the header title take up available space */\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-right: 35px;\r\n  margin-top: -20px;\r\n  flex-wrap: wrap; /* Allow wrapping of actions on smaller screens */\r\n}\r\n\r\n.moreActions {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-right: 35px;\r\n  flex-wrap: wrap; /* Allow wrapping of actions on smaller screens */\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .header {\r\n    flex-direction: column; /* Stack elements vertically on smaller screens */\r\n    align-items: flex-start;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .header h2 {\r\n    margin-bottom: 10px; /* Add space between the header and actions on smaller screens */\r\n  }\r\n\r\n  .actions {\r\n    margin-right: 0px;\r\n    margin-top: 10px;\r\n    width: 100%; /* Make actions take the full width on smaller screens */\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .search-wrapper {\r\n    width: 100%;\r\n    margin-right: 0px;\r\n    margin-bottom: 10px; /* Add margin to create space between search box and other elements */\r\n  }\r\n\r\n  .newDD {\r\n    /* width: 100%; */\r\n    margin-bottom: 10px;\r\n  }\r\n}\r\n\r\n.search-wrapper {\r\n  width: 160px;\r\n  height: 40px;\r\n  padding-left: 11px;\r\n  /* margin-top: 5px; */\r\n  border-radius: 5px;\r\n  margin-right: 8px;\r\n  padding: 5px 10px;\r\n  border: 1px solid lightgray;\r\n  border-radius: 4px;\r\n  position: relative;\r\n}\r\n\r\n.actual-search-wrapper {\r\n  width: 180px;\r\n  height: 40px;\r\n  padding-left: 11px;\r\n  border-radius: 5px;\r\n  margin-right: 8px;\r\n  padding: 10px 10px;\r\n  border: 1px solid lightgray;\r\n  border-radius: 4px;\r\n  position: relative;\r\n  font-size: 13px;\r\n}\r\n\r\n.form-control {\r\n  background-color: transparent;\r\n  border: none;\r\n  height: 100%;\r\n  /* font-size: 1.25rem; */\r\n  width: 100%;\r\n  /* margin-left: 15px; */\r\n}\r\n.form-control:focus {\r\n  outline: none;\r\n}\r\n.search-icon {\r\n  padding-left: 11px;\r\n  margin-top: 5px;\r\n  border-radius: 5px;\r\n  margin-right: 8px;\r\n}\r\n.get-app-button {\r\n  background-color: #ffffff;\r\n  color: #4a4a4a;\r\n  border: 1px solid #d5d5d5;\r\n  border-radius: 4px;\r\n  padding: 10px 20px;\r\n  font-size: 15px;\r\n  cursor: pointer;\r\n  margin-right: 10px;\r\n  height: 36px;\r\n}\r\n\r\n/* Dth */\r\n\r\n.new-driver-button {\r\n  background-color: #79c6e9;\r\n  color: #fff;\r\n  border: 1px solid #79c6e9;\r\n  border-radius: 4px;\r\n  padding: 10px 20px;\r\n  font-size: 15px;\r\n  cursor: pointer;\r\n  height: 36px;\r\n}\r\n\r\n.get-app-button:hover {\r\n  background-color: #edeff1;\r\n}\r\n.new-driver-button:hover {\r\n  background-color: #67bfe8;\r\n}\r\n\r\n.DriverTable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background-color: #fff;\r\n  border: none;\r\n}\r\n\r\n.DispatcherTable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background-color: #fff;\r\n  border: none;\r\n}\r\n\r\n.newDD {\r\n  align-items: center;\r\n  /* margin-right: 5px; */\r\n  margin-left: 10px;\r\n  margin-top: 0.4%;\r\n  border-radius: 50px;\r\n}\r\n\r\n.DriverTable th,\r\n.DriverTable td {\r\n  /* color: #4a4a4a !important; */\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 20px !important;\r\n  text-align: left;\r\n}\r\n\r\n.DispatcherTable th,\r\n.DispatcherTable td {\r\n  /* color: #4a4a4a !important; */\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 20px !important;\r\n  text-align: left;\r\n}\r\n\r\n.DriverTable th:nth-child(4),\r\n.DriverTable th:nth-child(5),\r\n.DriverTable td:nth-child(4),\r\n.DriverTable td:nth-child(5) {\r\n  font-weight: bold;\r\n}\r\n\r\n.DispatcherTable th:nth-child(4),\r\n.DispatcherTable th:nth-child(5),\r\n.DispatcherTable td:nth-child(4),\r\n.DispatcherTable td:nth-child(5) {\r\n  font-weight: bold;\r\n}\r\n\r\n/* Styles for tabs */\r\n.tabs {\r\n  display: flex;\r\n  margin-bottom: 20px;\r\n  margin-left: 30px;\r\n  margin-top: -10px;\r\n}\r\n\r\n.tabs button {\r\n  background-color: transparent;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  font-size: 17px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, color 0.3s ease,\r\n    border-bottom 0.3s ease;\r\n  color: #7c7c7c;\r\n  border-bottom: 2px solid transparent;\r\n}\r\n\r\n.tabs button.active {\r\n  background-color: transparent;\r\n  color: black;\r\n  border-bottom: 2px solid #72c2e7;\r\n}\r\n\r\n.daily-payment-content {\r\n  padding: 20px;\r\n  background-color: #fff;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.driver-inactive {\r\n  font-family: sans-serif;\r\n  color: rgb(223, 222, 222);\r\n}\r\n\r\n.driver-inactive tr {\r\n  color: rgb(227, 222, 222);\r\n}\r\n.driver-active {\r\n  font-family: sans-serif;\r\n}\r\n.Field {\r\n  margin: 8px;\r\n}\r\n\r\n.clickable-name {\r\n  cursor: pointer;\r\n}\r\n\r\n.clickable-name:hover {\r\n  color: #79c6e9;\r\n}\r\n\r\n.circular-initial {\r\n  display: inline-block;\r\n  width: 25px;\r\n  height: 25px;\r\n  border-radius: 50%;\r\n  background-color: #79c6e9;\r\n  color: white;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  line-height: 25px;\r\n  font-size: 14px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.circular-initiall {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 60;\r\n  height: 60;\r\n  border-radius: 50%;\r\n  background-color: #79c6e9;\r\n  color: white;\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.disabled-button {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n  pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
